import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KbBrakeApllicationFormsModuleComponent } from './kbBrakeApllicationForms-module.component';
import { AuthGuard, ConfigModule, I18nModule } from '@spartacus/core';
import { KbMyAccountLeftSideNavModule } from '../../my-account-left-sidenav/my-account-left-sidenav.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { BrakeAppChooseFileDialog } from './chooseFileDialog.component';
import { KbBrakeAppSearchFormComponent } from '../kb-brake-app-search-form/kb-brake-app-search-form.component';
import { PageComponentModule, PageSlotModule } from '@spartacus/storefront';
import { KbCustomerIdDropdownModule } from '../../kb-MyOwnPartNumbers/customer-id-drop-down/customer-id-drop-down.module';
import { BrakeAppAdminFormComponent } from '../brake-app-admin-form/brake-app-admin-form.component';
import { BrakeAdminSearchFormComponent } from '../brake-admin-search-form/brake-admin-search-form.component';
import { adminsearchCommentPopup } from '../brake-admin-search-form/adminSearchCommentPopup.component';
import { RouterModule } from '@angular/router';
import { SecureGuard } from 'src/app/services/Guards/secure.service';
import { BrakeAppEditFormComponent } from '../brake-app-edit-form/brake-app-edit-form.component';
import { BrakeAppAdminDialogPopupComponent } from '../brake-app-admin-form/brake-app-admin-dialog-popup/brake-app-admin-dialog-popup.component';
import { EnggReviewPopupComponent } from '../kb-brake-app-search-form/engg-review-popup/engg-review-popup.component';
import { BrakeAppPrivacyTermsPageComponent } from '../brake-app-privacy-terms-page/brake-app-privacy-terms-page.component';
import { kbRequiredErrorDivModule } from '../kbrequiredErrdiv.module';
import { KbPaginationModule } from 'src/app/customcomponents/kb-pagination/kb-pagination/kb-pagination.module';
@NgModule({
  declarations: [KbBrakeApllicationFormsModuleComponent,
    BrakeAppEditFormComponent,
    BrakeAppChooseFileDialog,
    adminsearchCommentPopup,
    KbBrakeAppSearchFormComponent,
    BrakeAdminSearchFormComponent,
    BrakeAppAdminFormComponent,
    BrakeAppAdminDialogPopupComponent,
    EnggReviewPopupComponent,
    BrakeAppPrivacyTermsPageComponent
  ],
  imports: [
    CommonModule,
    KbMyAccountLeftSideNavModule,
    KbCustomerIdDropdownModule,
    ReactiveFormsModule,
    FormsModule,
    I18nModule,
    RouterModule,
    BsDatepickerModule,
    TooltipModule,
    MatExpansionModule,
    MatDialogModule,
    PageSlotModule,
    KbPaginationModule,
    PageComponentModule,
    kbRequiredErrorDivModule,
    ConfigModule.withConfig({
      cmsComponents: {
        BendixADBFlexComponent: {
          component: KbBrakeApllicationFormsModuleComponent,
          guards: [SecureGuard, AuthGuard]
        },
        BendixADBSearchFlexComponent: {
          component: KbBrakeAppSearchFormComponent,
          guards: [SecureGuard, AuthGuard]
        },
        BendixADBAdminFlexComponent: {
          component: BrakeAdminSearchFormComponent,
          guards: [SecureGuard, AuthGuard]
        },
        BendixADBFormCommentsFlexComponent: {
          component: BrakeAppAdminFormComponent,
          guards: [SecureGuard, AuthGuard]
        },
        BendixADBEditFlexComponent: {
          component: BrakeAppEditFormComponent,
          guards: [SecureGuard, AuthGuard]
        },
        PrivacyTermsFlexComponent: {
          component: BrakeAppPrivacyTermsPageComponent,
          guards: [SecureGuard]
        }
      }
    })
  ]

})
export class KbBrakeApplicationFormsModule { }



